import React, { useState } from 'react';

interface MessageInputProps {
  onSendMessage: (message: string) => void;
  isMobile?: boolean;
  isDesktop?: boolean;
}

const MessageInput: React.FC<MessageInputProps> = ({ onSendMessage, isMobile, isDesktop }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent | React.KeyboardEvent) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      handleSubmit(e);
    }
  };

  return (
    <>
      {isMobile && (
        <div className="p-3 bg-white border-t border-outline-variant mb-16 md:hidden">
          <div className="flex items-center gap-2 bg-surface-container-low rounded-full px-4 py-1 border border-outline-variant">
            <input
              className="flex-grow bg-transparent border-none focus:ring-0 text-body-md"
              placeholder="Message..."
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button className="text-secondary p-2" onClick={handleSubmit}>
              <span className="material-symbols-outlined" data-icon="send" style={{ fontVariationSettings: "'FILL' 1" }}>send</span>
            </button>
          </div>
        </div>
      )}
      {isDesktop && (
        <footer className="p-gutter bg-surface border-t border-outline-variant hidden md:block">
          <div className="bg-surface-container-low rounded-2xl p-2 border border-outline-variant focus-within:border-primary focus-within:ring-1 focus-within:ring-primary transition-all shadow-inner">
            <div className="flex items-center gap-2 px-2 pb-2">
              <button className="p-2 rounded-lg hover:bg-surface-container-high text-outline transition-colors">
                <span className="material-symbols-outlined" data-icon="add_circle">add_circle</span>
              </button>
              <button className="p-2 rounded-lg hover:bg-surface-container-high text-outline transition-colors">
                <span className="material-symbols-outlined" data-icon="image">image</span>
              </button>
              <button className="p-2 rounded-lg hover:bg-surface-container-high text-outline transition-colors">
                <span className="material-symbols-outlined" data-icon="attach_file">attach_file</span>
              </button>
              <div className="w-[1px] h-6 bg-outline-variant mx-1"></div>
              <button className="p-2 rounded-lg hover:bg-surface-container-high text-outline transition-colors">
                <span className="material-symbols-outlined" data-icon="mood">mood</span>
              </button>
            </div>
            <div className="flex items-end gap-2 px-2">
              <textarea
                className="flex-1 bg-transparent border-none focus:ring-0 resize-none py-2 text-body-md max-h-32 min-h-[40px] font-body-md"
                placeholder="Type a message..."
                rows={1}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
              ></textarea>
              <button className="mb-1 w-10 h-10 rounded-xl bg-secondary text-on-secondary flex items-center justify-center hover:shadow-lg active:scale-95 transition-all" onClick={handleSubmit}>
                <span className="material-symbols-outlined" data-icon="send">send</span>
              </button>
            </div>
          </div>
          <div className="mt-3 flex justify-between items-center px-2">
            <div className="flex items-center gap-2">
              <span className="material-symbols-outlined text-[16px] text-outline" data-icon="lock">lock</span>
              <span className="text-[11px] text-outline font-label-md">Messages are encrypted and secure</span>
            </div>
            <span className="text-[11px] text-outline font-label-md">Press Enter to send</span>
          </div>
        </footer>
      )}
    </>
  );
};

export default MessageInput;